import classNames from "classnames";
import * as React from "react";
import styles from "./NewButtonsSelect.module.scss";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { ButtonWithSound } from "../../AudioProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Option = {
  id: string;
  name: string;
};
export const NewButtonsSelect = ({
  disabled = false,
  className,
  value,
  options,
  onChange,
  ...rest
}: {
  disabled?: boolean;
  value: string;
  options: Array<Option>;
  onChange: (value: Option) => void;
} & Omit<JSX.IntrinsicElements["div"], "onChange">) => {
  return (
    <div className={classNames("w-full", className)} {...rest}>
      {options.map((option) => {
        return (
          <ButtonWithSound
            disabled={disabled}
            type="button"
            onClick={() => onChange(option)}
            className={classNames(
              "btn",
              "flex",
              "justify-center",
              "items-center",
              "w-full",
              "rounded-lg",
              "bg-blue-900",
              "p-2",
              "opacity-70",
              "gap-1",
              styles.button,
              {
                [styles.active]: value === option.id,
              }
            )}
            key={option.id}
          >
            <FontAwesomeIcon icon={faCheck} fixedWidth />
            <span>{option.name}</span>
          </ButtonWithSound>
        );
      })}
    </div>
  );
};
